import { ServerClient } from 'common/utils/http/http-clients';
import { IPass } from '../payease.types';
import { ICreateTransactionRequest, ICreateTransactionResponse, IPayEaseService } from './payease.service.types';

class PayEaseService implements IPayEaseService {
  async getPasses(): Promise<IPass[]> {
    const res = await ServerClient.get<IPass[]>('/passes');
    return res.data;
  }

  async createTransaction(passId: string, optionId: string, request: ICreateTransactionRequest): Promise<ICreateTransactionResponse> {
    const res = await ServerClient.post<ICreateTransactionResponse>(`/passes/${passId}/options/${optionId}/transactions`, request);
    return res.data;
  }
}

const payEaseService: IPayEaseService = new PayEaseService();

export default payEaseService;
